// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const SteeringWheel = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width={size}
      height={size}
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <path d='M33,22.5c3.4-1.2,6.5-3,9.1-5.4' />
      <path d='M6,17c2.6,2.4,5.7,4.2,9,5.4' />
      <path d='M39,11.7c-3.4,1.1-6.6,2.9-9.3,5.2' />
      <path d='M20.7,32.5c-.3,1.6-.5,3.3-.5,5s.2,3.8.6,5.7' />
      <path d='M26.9,43.1c.4-1.8.6-3.7.6-5.7s-.2-3.3-.4-4.9' />
      <path d='M18.2,17c-2.7-2.3-5.8-4.1-9.2-5.2' />
      <circle fill={fill || 'none'} cx='24' cy='24' r='9.1' />
      <path
        fill={fill || 'none'}
        d='M24,.8C11.2.8.8,11.2.8,24s10.4,23.2,23.2,23.2,23.2-10.4,23.2-23.2S36.8.8,24,.8ZM24,43.4c-10.7,0-19.4-8.7-19.4-19.4S13.3,4.6,24,4.6s19.4,8.7,19.4,19.4-8.7,19.4-19.4,19.4Z'
      />
    </svg>
  );
};
